import createCrudApi from "@/app/services/baseApi";
const parceirosApi = createCrudApi('parceiros');

const { axios } = parceirosApi;

export default parceirosApi;
